import { BetslipFilterItem, C_FreeBetTicket, TicketBetslipModel } from "./";
import { BetslipProviderModel } from "./betslip-provider.model";

export interface ticketState {
  betSlip: BetslipProviderModel;
  filters: BetslipFilterItem[];
  filterSelected: BetslipFilterItem;
  freeBets: C_FreeBetTicket[];
  betbuilderSelection;
  processingFrom;
  processingItem;
  ticket: TicketBetslipModel;
}
